const GRID_SIZE = 8;

export default function spacing (num) {
  if (((num * GRID_SIZE) % (GRID_SIZE / 2)) === 0) {
    return `${num * GRID_SIZE}px`;
  }
  throw new Error(`Spacing num must be evenly divisible by ${GRID_SIZE / 2}`);
}
